export const MODERATION_REASONS = [
  {
    value: 'no_expertise_description',
    label: 'No description of expertise or contribution',
    detail:
      'Your comment does not describe what your team or institution can contribute to a consortium. Please include your relevant expertise, prior projects, and the role you are seeking.',
  },
  {
    value: 'no_project_abstract',
    label: 'No project abstract or research objectives',
    detail:
      'Your comment does not contain a substantive project abstract. Please include a clear description of your proposed project, its objectives, and the type of partners you are looking for.',
  },
  {
    value: 'off_topic',
    label: 'Off-topic or irrelevant to this funding call',
    detail:
      'Your comment does not relate to the scope of this funding call. Please ensure your message addresses the call\'s research areas and funding objectives.',
  },
  {
    value: 'spam_duplicate',
    label: 'Spam or duplicate posting',
    detail:
      'Your comment appears to be spam or a duplicate of another post. Please post only once per interest type and ensure your message is unique and substantive.',
  },
  {
    value: 'contact_only',
    label: 'Contact information only — no substantive content',
    detail:
      'Your comment contains only contact details with no substantive description of your expertise, project, or research interests. Please add meaningful content before sharing contact information.',
  },
  {
    value: 'incomplete_placeholder',
    label: 'Incomplete or placeholder text',
    detail:
      'Your comment appears to be incomplete or contains placeholder text. Please revise it with a complete and informative message.',
  },
  {
    value: 'self_promotion',
    label: 'Self-promotion without relevant context',
    detail:
      'Your comment promotes your organisation or work without connecting it to the specific requirements of this funding call. Please explain how your expertise is relevant to the call topics.',
  },
];

export const REASON_MAP = Object.fromEntries(
  MODERATION_REASONS.map((r) => [r.value, r])
);
